import React, { Fragment, PureComponent } from "react";
import { connect } from "react-redux";
import { PropTypes } from "prop-types";
import { Field } from "formik";

import FormikSemanticCheckbox from "./formik/FormikSemanticCheckbox.jsx";

import { selectCopy } from "../../state/reducers/locale/copySelector.js";

class EditOTPBlock extends PureComponent {
  static propTypes = {
    formikProps: PropTypes.object.isRequired,
    editAvailability: PropTypes.object.isRequired,
    violationErrors: PropTypes.object,
    copyKey: PropTypes.string.isRequired,

    copy: PropTypes.func.isRequired
  };

  static defaultProps = {
    copyKey: "project.details_panel"
  };

  render() {
    const {
      formikProps: { values },
      editAvailability: { available },
      violationErrors,
      copyKey,
      copy
    } = this.props;

    // Semantic ui react Checkbox requires a string or number for value, but a boolean for checked.
    // Checkbox also doesn't automatically set the initial checked value.
    // Hense the slight weirdness below.
    if (available) {
      return (
        <Fragment>
          <h5>{copy(`${copyKey}.otp_title`)}</h5>
          <p>{copy(`${copyKey}.otp_body`)}</p>
          <Field
            name="requiresUserVerification"
            label={copy(`${copyKey}.otp_checkbox_label`)}
            placeholder={copy(`${copyKey}.otp_checkbox_placeholder`)}
            required={false}
            checked={values.requiresUserVerification === 1}
            apiErrors={violationErrors}
            component={FormikSemanticCheckbox}
          />
        </Fragment>
      );
    }

    return null;
  }
}

const mapStateToProps = state => ({
  copy: selectCopy(state)
});

export default connect(mapStateToProps)(EditOTPBlock);
